import { CourseResourceApi, UpdateFileResourceBody, UpdateLinkResourceBody, courseResourcesApi } from "api";
import { useToaster } from "utils";
import { ModalHeader } from "../../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../../components/templates/Modals/ModalPadding";
import { IDropdownOption } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { COURSE_RESOURCE_TYPE, LINKABLE_RESOURCE_TYPES, ResourceForm, ResourceFormValues } from "./ResourceForm";

interface EditResourceModalProps {
  resource: CourseResourceApi | null;
  onCloseRequest: () => void;
  courseId: number;
  onSubmit: (resource: CourseResourceApi) => Promise<void>;
  folderOptions: IDropdownOption[];
}

export const EditResourceModal = ({
  courseId,
  resource,
  onCloseRequest,
  folderOptions,
  onSubmit,
}: EditResourceModalProps) => {
  const { showSuccess, showError } = useToaster();

  const onLinkSubmit = async (data: UpdateLinkResourceBody) => {
    if (!resource) {
      console.error("Resource is null");
      return;
    }
    try {
      await courseResourcesApi.updateLinkResource(courseId, resource.id, data);
      showSuccess("Materiał został edytowany");
      onCloseRequest();
      onSubmit({ ...resource, ...data });
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd");
    }
  };

  const onFileSubmit = async (data: UpdateFileResourceBody) => {
    if (!resource) {
      console.error("Resource is null");
      return;
    }
    try {
      await courseResourcesApi.updateFileResource(courseId, resource.id, data);
      showSuccess("Materiał został edytowany");
      onCloseRequest();
      onSubmit({ ...resource, ...data });
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd");
    }
  };

  const onSubmitHandler = async (data: ResourceFormValues) => {
    if (LINKABLE_RESOURCE_TYPES.includes(data.type) && data.link) {
      onLinkSubmit({
        name: data.name,
        description: data.description ?? "",
        link: data.link,
      });
      return;
    }
    if (data.type == COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE && data.resource) {
      onFileSubmit({
        name: data.name,
        description: data.description ?? "",
        resource: data.resource[0] as File,
      });
      return;
    }

    showError("Wystąpił błąd");
    console.error("Invalid form data", data);
  };

  return (
    <PaziaModal
      id="edit-resource-modal"
      onCloseRequest={() => {
        onCloseRequest();
      }}
      isOpen={resource != null}
      size="xl"
    >
      {resource != null && (
        <ModalPadding>
          <ModalHeader>Edytuj materiał</ModalHeader>
          <ResourceForm
            resource={resource}
            onSubmit={onSubmitHandler}
            courseId={courseId}
            folderOptions={folderOptions}
            onCancel={() => {
              onCloseRequest();
            }}
          />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};
